/** Multiplier to calculate registration/onboarding progress bar */
export const REGISTER_INCREMENT_MULTIPLIER = 14;

export const JOIN_CODE_MAX_LENGTH = 16;
